
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BeevisionAuditLogsList from './BeevisionAuditLogsList';
import BeevisionAuditLogDetails from './BeevisionAuditLogDetails';

const BeevisionAuditLogsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<BeevisionAuditLogsList />} />
      <Route path="/:id" element={<BeevisionAuditLogDetails />} />
    </Routes>
  );
};

export default BeevisionAuditLogsPage;
